import { render, staticRenderFns } from "./MultiTagBrowser.vue?vue&type=template&id=3b57815e&scoped=true"
import script from "./MultiTagBrowser.vue?vue&type=script&lang=js"
export * from "./MultiTagBrowser.vue?vue&type=script&lang=js"
import style0 from "./MultiTagBrowser.vue?vue&type=style&index=0&id=3b57815e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57815e",
  null
  
)

export default component.exports